import { HolidayGiftIcon, ReferralIcon } from 'assets/icons';
import { IconButton } from 'components';
import { useActiveMember, useActiveMemberUpdate } from 'hooks';
import useOnMount from 'hooks/utils/useOnMount/useOnMount';
import jwt from 'jsonwebtoken';
import { DateTime } from 'luxon';
import { useRef, useState } from 'react';
import './impactPopup.scss';
import NotificationBadge from './NotificationBadge';

const ImpactPopupWidget = () => {
  const impactPopupWidgetKey = process.env.REACT_APP_IMPACT_POPUP_WIDGET_KEY;
  const impactAccountSidKey = process.env.REACT_APP_IMPACT_ACCOUNT_SID_KEY;
  const impactAuthTokenKey = process.env.REACT_APP_IMPACT_AUTH_TOKEN_KEY;

  const member = useActiveMember();
  const [updateKey] = useActiveMemberUpdate();
  const hasReferralCount = useRef<boolean>((member.referralCount ?? 0) > 0);
  const impactPopupBtnRef = useRef<HTMLButtonElement>(null);
  const [tokenReady, setTokenReady] = useState(false);
  const now = DateTime.now();
  const isHolidayTime = now.month === 12;

  useOnMount(() => {
    const payload = {
      user: {
        id: member.id,
        accountId: member.id,
        firstName: member.firstName,
        lastName: member.lastName,
        email: member.email,
      },
    };

    const secretKey: jwt.Secret = impactAuthTokenKey!;

    const headers = {
      alg: 'HS256',
      typ: 'JWT',
      kid: impactAccountSidKey,
    };

    const options: jwt.SignOptions = {
      expiresIn: '7d',
      header: headers,
    };

    const token: string = jwt.sign(payload, secretKey, options);

    window.impactToken = token;
    window.dispatchEvent(
      new CustomEvent('impact:token-ready', {
        detail: { token },
      })
    );
    setTokenReady(true);
  });

  function triggerImpactPopup() {
    if (impactPopupBtnRef.current) {
      updateKey('referralCount', 0).then((result) => {
        if (result.errors && result.errors.length === 0) {
          hasReferralCount.current = (result.data?.updateMember?.referralCount ?? 0) > 0;
        }
      });
      impactPopupBtnRef.current.click();
    }
  }

  return (
    <div>
      <div className="div-impact-icon">
        {isHolidayTime ? (
          <IconButton svg={HolidayGiftIcon} className={'holiday-icon'} onClick={triggerImpactPopup} />
        ) : (
          <IconButton svg={ReferralIcon} onClick={triggerImpactPopup} />
        )}
        {hasReferralCount.current && <NotificationBadge />}
      </div>
      {tokenReady && (
        <impact-popup widget={'p/' + impactPopupWidgetKey + '/w/referrerWidget'}>
          <button ref={impactPopupBtnRef} hidden />
        </impact-popup>
      )}
    </div>
  );
};

export default ImpactPopupWidget;
